import reduxStore from 'redux/store'

export default (url) => {
    const form = document.createElement("form");
    form.setAttribute('action', url);
    form.setAttribute('method', 'post');
    form.setAttribute('hidden', 'true');
    const csrfInput = document.createElement("input");
    csrfInput.setAttribute('name', 'CSRFToken');
    csrfInput.setAttribute('hidden', 'true');
    csrfInput.setAttribute('type', 'text');
    csrfInput.value = reduxStore.getState().resources.userData.csrf;
    form.append(csrfInput);
    document.body.appendChild(form);
    form.submit();
}